<template>
  <v-card class="mb-6 card-boletim" :class="{'border-error': statusCard === 'Cancelado'}" :loading="loading">
    <v-card-title class="d-flex flex-column align-start">
      <div class="status-chip-group d-flex ma-0 pa-0">
        <v-chip class="status-chip" small>
          <span :class="statusCard === 'Cancelado' ? 'status-text-cancelado' : 'status-text'">{{ statusCard }}</span>
        </v-chip>
      </div>
      <div class="label-titulo-boletim">Lote {{ boletim.nrLoteControle }}</div>
      <div class="titulo-boletim mt-2">{{ boletim.nmProdutor }}</div>
    </v-card-title>
    <v-card-text class="pb-0">
      <v-row class="mx-0">
        <span>
          <div class="label-data-card-boletim">
            Data de criação
          </div>
          <div class="data-card-boletim">
            {{ boletim.dtEmissao | dateFormat }}
          </div>
        </span>
        <span class="ml-6">
          <div class="label-data-card-boletim">
            Número do boletim sanitário
          </div>
          <div class="data-card-boletim">
            {{ boletim.idBoletimSanitario }}
          </div>
        </span>
      </v-row>

      <v-row class="mx-0 mt-4 mb-10">
        <span>
          <div class="label-data-card-boletim">
              GTAs
          </div>
          <div class="d-flex flex-wrap boletim-chip-group">
            <v-chip v-for="(saida, idx) in boletim.saidaAnimais" :key="`chipGTA__${idx}`" class="mt-1 mr-2">
              {{ `${saida.nrGta}-${saida.dsSerieGta}` }}
            </v-chip>
          </div>
        </span>
      </v-row>

    </v-card-text>
    <v-card-actions class="pt-0">
      <confirmation-dialog :item="boletim" @confirmed="cancelarBoletim"
                       titulo="Cancelar boletim sanitário"
                       ds-acao="Deseja mesmo cancelar o boletim sanitário?"
                       mensagem="Ao cancelar esse boletim sanitário não será possível desfazer a ação.">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon size="16" color="#799596">fas fa-trash</v-icon>
          </v-btn>
        </template>
      </confirmation-dialog>
      <v-spacer />
      <v-btn color="#799596" text :retain-focus-on-click="false"
             :to="`/boletimSanitario/${boletim.idBoletimSanitario}`">
        EDITAR
      </v-btn>
      <v-btn color="#00A5A2" text @click="gerarBoletimSanitarioPDF" :loading="gerandoPDF"
             :retain-focus-on-click="false">
        ACESSAR BOLETIM
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ConfirmationDialog from "../ConfirmationDialog";
export default {
  name: "BoletimSanitarioCard",
  components: {ConfirmationDialog},
  props: {
    boletim: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    deleting: false,
    loading: false,
    gerandoPDF: false,
  }),
  computed: {
    statusCard() {
      switch (this.boletim.cdStatusBoletimSanitario) {
        case 6:
          return 'Cancelado'
        case 1:
          return 'Informações'
        case 2:
          return 'Medicações'
        case 3:
          return 'Sinais clínicos'
        case 4:
          return 'Mercado destino'
        case 5:
          return 'Finalizado'
        default:
          return ''
      }
    },
  },
  methods: {
    cancelarBoletim() {
      this.loading = true
      this.$axios.post(`boletim-sanitario-status/cancelar-boletim-sanitario/${this.boletim.idBoletimSanitario}/`)
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) return

            this.$emit('cancelarBoletim')
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
            this.deleting = false
          })
          .finally(() => {
            this.loading = false
            this.deleting = false
          })
    },
    gerarBoletimSanitarioPDF() {
      this.gerandoPDF = true
      const idBoletimSanitario = this.boletim.idBoletimSanitario
      this.$axios.get(`boletim-sanitario/${idBoletimSanitario}/boletim-sanitario-digital-pdf/`, {
        responseType: "blob"
      }).then((res) => {
        if (res.data.size === 0) {
          this.$store.commit("setSnack", {type: "error", msg: 'Erro ao gerar PDF'})
          return
        }
        let blob = new Blob([res.data], {type: 'application/octet-stream'})
        let a = document.createElement('a');
        a.href = URL.createObjectURL(blob)
        a.download = `boletim_sanitario_${this.boletim.idBoletimSanitario}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(error => {
        this.$store.commit("setSnack", {type: "error", msg: error})
      })
      .finally(() => this.gerandoPDF = false)
    }
  },
}
</script>

<style scoped lang="scss">
.label-titulo-boletim {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #35565B;
}

.titulo-boletim {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.15px;
  color: #35565B;
}

.label-data-card-boletim {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #799596;
}

.data-card-boletim {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0.5px;
  color: #35565B;
}

.border-error {
  border: 1px solid #FF5252;
}

.status-chip-group {
  position: absolute;
  right: 4px;
  top: 4px;
}

.status-chip {
  background-color: #FFFFFF !important;
}

.status-text {
  font: normal normal medium 10px/13px Roboto;
  text-transform: capitalize;
  letter-spacing: 0;
  color: #282828;
  opacity: 0.9;
}

.status-text-cancelado {
  color: #FF5252;
}

</style>